/**
 * User-side auth store. Smaller than the admin version — no menus/nodes.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface UserProfile {
  id: number;
  /** Legacy PHP player number (10xxxx) for display — not the internal Node id. */
  player_number?: string | null;
  username: string;
  email: string | null;
  phone: string | null;
  level_code: string;
  invite_code: string;
  referrer_id: number | null;
  status: string;
  balances: Record<string, string>;
  profile_metrics?: {
    trading_credit: number;
    invest_star: number;
    account_category: string;
    service_level: string;
    reward_level_code?: string | null;
    space_station: boolean;
  };
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  profile: UserProfile | null;
  setTokens: (a: string, r: string) => void;
  setProfile: (p: UserProfile) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      profile: null,
      setTokens: (accessToken, refreshToken) => set({ accessToken, refreshToken }),
      setProfile: (profile) => set({ profile }),
      clear: () => set({ accessToken: null, refreshToken: null, profile: null }),
    }),
    { name: 'uo-user-auth' },
  ),
);
